import React, { useEffect, useState, useReducer, useContext, Fragment } from 'react'
import { ThemeContext } from 'styled-components'
import { Flex, Box } from 'reflexbox'
import { useParams, Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import Loader from 'components/Loader'
import Card from 'components/Card'
import Button from 'components/Button'
import Breadcrumb from 'components/Breadcrumb'
import { ActivateModal } from 'components/Modal'
import { Text, SemiTitle, Title } from 'components/Typography'

import { reducer } from 'helpers/loadingReducer'
import { formatBeneficiaryDocument } from 'helpers/formatters'
import { getBeneficiary } from 'services/beneficiaries'

const Show = () => {
  const theme = useContext(ThemeContext)
  const { id: beneficiaryID } = useParams()
  const [requestStatus, dispatch] = useReducer(reducer, { isLoading: true, error: false })
  const [beneficiaryData, setBeneficiaryData] = useState(null)
  const [confirmationModalisOpened, setConfirmationModalIsOpened] = useState(false)
  const [beneficiaryToBeActivated, setBeneficiaryToBeActivated] = useState(null)
  const [beneficiaryStatus, setBeneficiaryStatus] = useState('-')

  useEffect(() => {
    const getBeneficaryData = async () => {
      try {
        const { data } = await getBeneficiary(beneficiaryID)

        const translatedStatus = () => {
          switch (data.status) {
            case 'active':
              return 'Ativo'
            case 'inactive':
              return 'Inativo'
            case 'waiting':
              return 'A Ativar'
            default:
              return '-'
          }
        }

        setBeneficiaryStatus(translatedStatus())
        setBeneficiaryData({ ...data, is_active: data.status === 'active' })
        dispatch({ type: 'success' })
      } catch (e) {
        console.log(e)
        toast.error('Falha ao carregar dados.')
        dispatch({ type: 'error' })
      }
    }

    getBeneficaryData()
  }, [confirmationModalisOpened])

  const breadcrumbPath = [
    {
      label: 'Beneficiários',
      link: '/prepaid-purchase/beneficiaries',
    },
    {
      label: beneficiaryData?.name,
    },
  ]

  return (
    <Flex flexDirection='column'>
      {requestStatus.isLoading ? (
        <Flex width={1} height={268} alignItems='center' justifyContent='center'>
          <Loader />
        </Flex>
      ) : (
        <Fragment>
          <Breadcrumb children={breadcrumbPath} />

          <Flex alignItems='center' justifyContent='space-between' width={1} mb={32}>
            <Title as='h3'>{beneficiaryData?.name}</Title>
            <Flex justifyContent='flex-end' width={2 / 3}>
              <Button
                variant={beneficiaryData?.is_active ? 'tertiary' : 'primary'}
                onClick={() => {
                  setConfirmationModalIsOpened(true)
                  setBeneficiaryToBeActivated({ id: beneficiaryID, is_active: beneficiaryData?.is_active })
                }}
                mr={24}
              >
                {beneficiaryData?.is_active ? 'Desativar' : 'Ativar'}
              </Button>
              <Link to={`/prepaid-purchase/beneficiaries/edit/${beneficiaryData?.name}/${beneficiaryID}`}>
                <Button outlined>Editar</Button>
              </Link>
            </Flex>
          </Flex>

          <Card minHeight={268}>
            {requestStatus.error ? (
              <Text>Não foi possivel carregar os dados do beneficiário no momento.</Text>
            ) : (
              <Flex flexDirection='column'>
                <Box mb={32}>
                  <SemiTitle color={theme.colors.grays.N500}>CPF/CNPJ</SemiTitle>
                  <Text>{beneficiaryData?.document ? formatBeneficiaryDocument(beneficiaryData?.document) : '-'}</Text>
                </Box>
                <Box mb={32}>
                  <SemiTitle color={theme.colors.grays.N500}>Email</SemiTitle>
                  <Text>{beneficiaryData?.email ? beneficiaryData?.email : '-'}</Text>
                </Box>
                <Box mb={32}>
                  <SemiTitle color={theme.colors.grays.N500}>Dia de cobrança</SemiTitle>
                  <Text>{beneficiaryData?.activation_day || '-'}</Text>
                </Box>
                <Box mb={32}>
                  <SemiTitle color={theme.colors.grays.N500}>Status</SemiTitle>
                  <Text>{beneficiaryStatus}</Text>
                </Box>
                <Box mb={32}>
                  <SemiTitle color={theme.colors.grays.N500}>Grupos</SemiTitle>

                  {beneficiaryData?.groups.length ? (
                    beneficiaryData?.groups.map(({ id, name }) => (
                      <Box key={id}>
                        <Link to={`/prepaid-purchase/groups/attribution/${id}`}>{name}</Link>{' '}
                      </Box>
                    ))
                  ) : (
                    <Text>-</Text>
                  )}
                </Box>
              </Flex>
            )}
          </Card>
          <ActivateModal
            isOpened={confirmationModalisOpened}
            setIsOpened={setConfirmationModalIsOpened}
            beneficiary={beneficiaryToBeActivated}
          />
        </Fragment>
      )}
    </Flex>
  )
}

export default Show
